module.exports = __webpack_public_path__ + "img/日野凱斗.84712f04.jpg";